var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadyGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "46q9pejrma"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DBEFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD92FE",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5.976a11.444 11.444 0 0 1 6.442 1.968 11.596 11.596 0 0 1 3.113 3.113 11.446 11.446 0 0 1 1.968 6.442 11.444 11.444 0 0 1-1.968 6.442 11.596 11.596 0 0 1-3.113 3.114 11.446 11.446 0 0 1-6.442 1.968 11.444 11.444 0 0 1-6.442-1.968 11.596 11.596 0 0 1-3.113-3.114A11.446 11.446 0 0 1 .977 12.5a11.444 11.444 0 0 1 1.968-6.442 11.596 11.596 0 0 1 3.113-3.113A11.444 11.444 0 0 1 12.5.976m0-.976C5.596 0 0 5.596 0 12.5 0 19.403 5.596 25 12.5 25S25 19.404 25 12.5 19.403 0 12.5 0zm4.992 19.078c-1.45 1.075-3.164 1.642-4.877 1.642a8.9 8.9 0 0 1-2.666-.403 8.224 8.224 0 0 1-2.443-1.24.488.488 0 1 0-.58.785 9.22 9.22 0 0 0 2.73 1.387 9.878 9.878 0 0 0 2.96.448c1.928 0 3.843-.639 5.457-1.835a.489.489 0 0 0-.58-.784zm-3.795-5.38v1.744a2.043 2.043 0 1 0 4.086 0v-7.38a2.043 2.043 0 1 0-4.086 0v4.434h-2.396V8.061a2.043 2.043 0 1 0-4.086 0v7.381a2.043 2.043 0 1 0 4.086 0V13.7h2.396z",
    fill: "url(#46q9pejrma)",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadyGradient);
export default __webpack_public_path__ + "static/media/heady-gradient.43f1b1ed6bcfa9821881f874d10ab3d4.svg";
export { ForwardRef as ReactComponent };